/** @deprecated use marketplace-ui-reviews */
export const ReportReviewReasons = {
  VIOLATION: 'VIOLATION',
  DUPLICATE: 'DUPLICATE',
  BAD_AUTHOR: 'BAD_AUTHOR',
  OFFENSIVE: 'OFFENSIVE',
  OTHER: 'OTHER'
};
/** @deprecated use marketplace-ui-reviews */

export const ReportReplyReasons = {
  VIOLATION: 'VIOLATION',
  OFFENSIVE: 'OFFENSIVE',
  BAD_AUTHOR: 'BAD_AUTHOR',
  OTHER: 'OTHER'
};
/** @deprecated use marketplace-ui-reviews */

export const Reportables = {
  REVIEW: 'REVIEW',
  REPLY: 'REPLY'
};
/** @deprecated use marketplace-ui-reviews */

export const ReportReasons = {
  [Reportables.REVIEW]: ReportReviewReasons,
  [Reportables.REPLY]: ReportReplyReasons
};